// pages/Home.jsx
import '../styles/home.css';
import lady from '../assets/lady-reading.jpeg'
import lab from '../assets/lab-counter.jpeg'
import { useNavigate } from "react-router-dom";
function Home() {
  const navigate = useNavigate();
  return ( 
    <div className = "Home">
      <div className = "Mission">
        <img src={lab} alt="Home" />
        <div className = "Mission-Text">
        <h1 className = "Mission-Title">Precision Care for Every Lab</h1>
        <p className = "Mission-Body"> 
          Our company is dedicated to providing you with excellent customer service and satisfaction. 
          With our team’s quick response time and years of experience, we strive to keep your lab running efficiently and effectively with little to no downtime. 
          We value our customers and will always treat them with honesty, integrity, and respect. 
          That is our promise to you.
        </p>
         <button className="Get-Started-Button" onClick={() => navigate("/contact-us")}> Get Started </button>
        </div>
      </div>
      <div className="Lab-Equip-Maintenance">
        <h2 className="Lab-Equip-Maintenance-Title">LAB EQUIPMENT MAINTENANCE</h2>
        <h2 className="Lab-Equip-Maintenance-Sub-Title">From a Reputable Service Company </h2>
        <p className="Lab-Equip-Maintenance-Body"> 
          Having well-maintained lab devices is necessary for laboratory procedures and scientific research facilities. 
          However, handling complex and technologically advanced equipment is no easy task. This is where DC Biomedical Services, LLC comes in. 
          For more than 10 years, we have been providing high-quality equipment maintenance and repair for histology and pathology devices. 
          We serve laboratories, hospitals, and research facilities in the Midwest. 
          Our goal is to help you deliver accurate and quality results through efficient and timely equipment maintenance and repair services. 
          We are a nationally certified MBE company certified through the NMSDC. 
          (National Minority Supplier Development Council)
        </p>
      </div>
      <div className = "Why-Trust-Us">
        <div className = "Why-Trust-Us-Overlay"></div>
        <h2 className = "Why-Trust-Us-Title"> Why Trust Us for Equipment Maintenance? </h2>
        <p className = "Why-Trust-Us-Body"> 
          At DC Biomedical Services, LLC, we understand the significance of lab equipment in the productivity and efficiency of hospitals, laboratories, and research facilities. 
          We have extensive knowledge and experience in the industry. 
          When you choose us, you can be confident that you have a dependable partner that you can turn to especially in an emergency. 
          We are here for you to ensure the smooth daily operation of your organization.
        </p>
      </div>
      <div className = "Inquire">
        <img src={lady} alt="Inquire About Maintain and Repair Services" />
        <div className = "Inquire-Text">
        <h2 className = "Inquire-Title"> Inquire About Maintenance and Repair Services </h2>
        <p> 
          Allow us to put our expertise to work for you! 
          We can help you ensure the optimum performance of your lab devices through our reliable equipment repair and maintenance. 
          Reach out to us to learn more about our services. 
          Our friendly staff will gladly give you the information you need.
        </p>
        <button className="Service-Button" onClick={() => navigate("/contact-us")}> Contact Us
        </button>
        </div>
      </div>
    </div>
  );
}
export default Home;
